import React from "react"

import t from "frontend/utils/translations"
import { getIncentivizedUploadData } from "frontend/utils/upload"

import styles from "./IncentivizedUploadHeading.module.css"

export default function IncentivizedUploadHeading() {
  const { title } = getIncentivizedUploadData()

  return (
    <>
      <span className={styles.heading}>{t("upload.incentivized.heading")}</span>{" "}
      <span className={styles.title}>{title}</span>
    </>
  )
}
